import { combineReducers } from 'redux';
import payouts  from './payoutsReducer';
import auth from "./authReducer";
import affiliates from "./affiliateReducer";
import products from "./productsReducer";
import salesGroups from "./salesGroupReducer";
import clients from "./clientReducer";
import registerAppUser from "./registerAppUserReducer";
import languages from "./languageReducer";
import items from "./itemReducer";
import termsAndConditions from "./termsAndConditionsReducer";


const frontendReducers = combineReducers({
	auth,
	affiliates,
  payouts,
  products,
  salesGroups,
  clients,
  registerAppUser,
  languages,
  items,
  termsAndConditions
});

export default frontendReducers;